export default __webpack_public_path__ + "static/media/streamyard1.88e959f1.JPG";